module.exports = __webpack_public_path__ + "img/js30clock.0c7fbc08.png";